<template>
  <v-container class="custom-container">
    <!-- Toolbar -->
    <v-app-bar app :color="isDark ? '#2A2A2A' : 'primary'" :dark="isDark">
      <!-- Back Button -->
      <v-btn icon @click="goToProjectDetails" class="back-btn">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>
        <v-icon icon="mdi-file-document-outline"></v-icon> &nbsp; Pages in: <strong>{{ document.name }}</strong>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog v-model="assignDialog" max-width="500px" @keydown.enter="selectedCollaborators.length > 0 && assignPages()" @keydown.esc="assignDialog = false">
  <v-card>
    <v-card-title>
      <span class="headline">Assign Pages to Collaborators</span>
    </v-card-title>
    <v-card-text>
      <v-form ref="assignForm">
        <v-autocomplete
          v-model="selectedCollaborators"
          :items="users"
          item-title="username"
          item-value="id"
          label="Collaborators"
          chips
          multiple
          outlined
        ></v-autocomplete>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="assignPages">
        Assign
      </v-btn>
      <v-btn color="red darken-1" text @click="assignDialog = false">
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

      <v-menu>
  <template v-slot:activator="{ props }">
    <v-btn
      v-if="canManagePages"
      color="white"
      class="toolbar-btn"
      v-bind="props"
    >
    <v-icon>mdi-checkbox-multiple-marked-outline</v-icon>
    &nbsp; Manage Selected
    </v-btn>
  </template>
  <v-list>
    <v-list-item @click.stop="toggleSelectAll">
  <v-list-item-content class="d-flex align-center">
    <v-checkbox
      :indeterminate="isSomeSelected"
      :input-value="isAllSelected"
      hide-details
    />
    <span class="ml-2">Select All</span>
  </v-list-item-content>
</v-list-item>




    <v-list-item
  :disabled="selectedPages.length === 0"
  @click="openAssignDialog"
>
  <v-list-item-title>Assign to</v-list-item-title>
</v-list-item>

    <v-list-item
      :disabled="selectedPages.length === 0"
      @click="handleDeletePages"
    >
      <v-list-item-title>Delete</v-list-item-title>
    </v-list-item>
    <v-list-item
      :disabled="selectedPages.length === 0"
      @click="openExportDialog"
    >
      <v-list-item-title>Export to ALTO</v-list-item-title>
    </v-list-item>
  </v-list>
</v-menu>

    <!-- Assignments Overlay Button -->
    <v-btn
      v-if="canManagePages"
      color="white"
      class="toolbar-btn"
      @click="openAssignmentsDialog"
    >
      <v-icon>mdi-account-arrow-right</v-icon>
      &nbsp; Assignments
    </v-btn>

    <!-- View Mode Toggle Button -->
    <v-btn
      color="white"
      class="toolbar-btn"
      @click="toggleViewMode"
      :disabled="pages.length === 0"
      :title="pages.length === 0 ? 'No pages to display' : (viewMode === 'grid' ? 'Switch to Table View' : 'Switch to Grid View')"
    >
      <v-icon>{{ viewMode === 'grid' ? 'mdi-table' : 'mdi-view-grid-outline' }}</v-icon>
      &nbsp; {{ viewMode === 'grid' ? 'Table View' : 'Grid View' }}
    </v-btn>

<v-dialog v-model="exportDialog" max-width="500px" @keydown.enter="confirmExport()" @keydown.esc="exportDialog = false">
      <v-card class="export-card">
        <v-card-title class="export-card-title">
          Export Selected Pages
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-list dense>
              <v-subheader>Selected Pages</v-subheader>
              <v-list-item v-for="page in selectedPagesDetails" :key="page.id">
                <v-list-item-content>
                  <v-list-item-title>Page {{ page.number }} (ID: {{ page.id }})</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider class="my-3"></v-divider>
            <v-switch v-model="exportOptions.includeImages" label="Include Images" inset></v-switch>
            <v-switch
  v-model="exportOptions.includeLineInfo"
  label="Include Baseline & Masks"
  inset
></v-switch>
            <v-switch v-model="exportOptions.includeTranscriptions" label="Include Transcriptions" inset></v-switch>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="exportDialog = false">Cancel</v-btn>
          <v-btn text color="blue" @click="confirmExport">Export</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <!-- Add and Import Page Buttons -->
      <v-btn v-if="canManagePages" color="white" class="toolbar-btn" @click="openCreatePageDialog">
        <v-icon>mdi-file-plus</v-icon>
    &nbsp; Add Page
      </v-btn>
      <v-btn v-if="canManagePages" color="white" class="toolbar-btn" @click="openImportPageDialog">
        <v-icon>mdi-file-import-outline</v-icon>
    &nbsp; Import Page
      </v-btn>
      <v-btn v-if="canManagePages" color="white" class="toolbar-btn" @click="openProjectsBrowserDialog">
        <v-icon>mdi-source-repository</v-icon>
    &nbsp; Browse Projects
      </v-btn>
    </v-app-bar>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="primary"
    ></v-progress-circular>

    <!-- Pages List (Grid View) -->
    <v-row v-if="viewMode === 'grid' && pages.length > 0" dense no-gutters>
      <v-col
        v-for="page in pages"
        :key="page.id"
        cols="auto"
        class="page-card"
      >
        <v-card class="clickable-card" @click="goToPage(page.id)">
          <div class="image-container">
            <v-img :src="page.image" height="200px"></v-img>
<div class="status-row">
  <!-- Segmentation -->
  <div class="status-item">
    <v-tooltip location="bottom">
      <template #activator="{ props }">
        <v-icon
          v-bind="props"
          class="status-icon"
          :color="importColor(page.segmentation_import_status)"
          :style="{ opacity: page.segmentation_import_status ? 1 : 0.5 }"
        >
          mdi-segment
        </v-icon>
      </template>
      <div class="status-tip">
        <span class="status-dot" :style="{ backgroundColor: importColor(page.segmentation_import_status, true) }"></span>
        <span>Segmentation — {{ importLabel(page.segmentation_import_status) }}</span>
      </div>
    </v-tooltip>
  </div>

  <!-- Transcription -->
  <div class="status-item">
    <v-tooltip location="bottom">
      <template #activator="{ props }">
        <v-icon
          v-bind="props"
          class="status-icon"
          :color="importColor(page.transcription_import_status)"
          :style="{ opacity: page.transcription_import_status ? 1 : 0.5 }"
        >
          mdi-translate-variant
        </v-icon>
      </template>
      <div class="status-tip">
        <span class="status-dot" :style="{ backgroundColor: importColor(page.transcription_import_status, true) }"></span>
        <span>Transcription — {{ importLabel(page.transcription_import_status) }}</span>
      </div>
    </v-tooltip>
  </div>

  <!-- Source Link -->
  <div class="status-item">
    <v-tooltip
      :text="page.origin_url ? 'View in eScriptorium' : 'Source unavailable'"
      location="bottom"
    >
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          size="x-small"
          variant="text"
          :disabled="!page.origin_url"
          :href="page.origin_url"
          target="_blank"
          @click.stop
          class="source-btn"
        >
          <img
            :src="require('@/assets/escriptorium.png')"
            width="18"
            height="18"
            :style="{ opacity: page.origin_url ? 1 : 0.3 }"
          />
        </v-btn>
      </template>
    </v-tooltip>
  </div>
</div>

            <v-checkbox
            v-if="canManagePages"
  v-model="selectedPages"
  :value="page.id"
  class="page-checkbox"
  hide-details
  @click.stop
></v-checkbox>
<!-- deleted delete button -->

          </div>
          <v-card-title><p class="page-number">Page {{ page.number }}</p></v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <!-- Table View -->
    <v-card v-if="viewMode === 'table'">
      <div v-if="pages.length > 0">
        <v-card-title class="d-flex align-center pe-2">
          <v-text-field
            v-model="search"
            density="compact"
            label="Search"
            prepend-inner-icon="mdi-magnify"
            variant="solo-filled"
            flat
            hide-details
            single-line
          ></v-text-field>
        </v-card-title>
        <v-divider></v-divider>
        <v-data-table
          v-model:sort-by="sortBy"
          :headers="pageHeaders"
          :items="filteredPages"
           item-value="id"
           class="elevation-2"
           dense
           hide-default-footer
         >
          <!-- Header for Page # with inline filter input -->
          <template v-slot:header.number="{ column }">
            <div class="column-filter">
              <span class="header-label">{{ column.title }}</span>
              <v-text-field
                v-model="filters.number"
                density="compact"
                variant="outlined"
                hide-details
                placeholder="#"
                class="filter-input"
                clearable
                @click.stop
              />
            </div>
          </template>
          <!-- Custom header for Created On -->
          <template v-slot:header.created_at="{ column }">
            <div class="sortable-header" @click="togglePageDateSort" role="button" :aria-label="`Sort by Created On ${currentPageDateSort === 'asc' ? 'descending' : 'ascending'}`">
              <span>Created On</span>
              <v-icon size="16" class="ms-1 sort-icon" v-if="currentPageDateSort === 'asc'">mdi-arrow-up</v-icon>
              <v-icon size="16" class="ms-1 sort-icon" v-else>mdi-arrow-down</v-icon>
            </div>
          </template>
          <!-- Header checkbox -->
          <template v-slot:header.select="{ }">
            <v-checkbox
              :indeterminate="isSomeSelected"
              :input-value="isAllSelected"
              @click.stop="toggleSelectAll"
              hide-details
              density="compact"
            ></v-checkbox>
          </template>
          <!-- Body rows -->
          <template v-slot:body="{ items }">
            <tr
              v-for="page in items"
              :key="page.id"
              @click="goToPage(page.id)"
              class="clickable-row"
            >
              <td>
                <v-checkbox
                  v-model="selectedPages"
                  :value="page.id"
                  hide-details
                  density="compact"
                  @click.stop
                ></v-checkbox>
              </td>
              <td>Page {{ page.number }}</td>
              <td class="text-center">{{ formatPageCreated(page.created_at) }}</td>
              <td class="text-center">
                <v-tooltip location="bottom">
                  <template #activator="{ props }">
                    <v-chip
                      v-bind="props"
                      class="status-chip"
                      :color="chipColor(page.segmentation_import_status)"
                      :variant="chipVariant(page.segmentation_import_status)"
                      size="small"
                      label
                    >
                      <v-icon
                        size="16"
                        class="me-1"
                        :style="{ opacity: page.segmentation_import_status ? 1 : 0.6 }"
                        :color="chipIconColor(page.segmentation_import_status)"
                      >mdi-segment</v-icon>
                      {{ importLabel(page.segmentation_import_status) }}
                    </v-chip>
                  </template>
                  <span>Segmentation — {{ importLabel(page.segmentation_import_status) }}</span>
                </v-tooltip>
              </td>
              <td class="text-center">
                <v-tooltip location="bottom">
                  <template #activator="{ props }">
                    <v-chip
                      v-bind="props"
                      class="status-chip"
                      :color="chipColor(page.transcription_import_status)"
                      :variant="chipVariant(page.transcription_import_status)"
                      size="small"
                      label
                    >
                      <v-icon
                        size="16"
                        class="me-1"
                        :style="{ opacity: page.transcription_import_status ? 1 : 0.6 }"
                        :color="chipIconColor(page.transcription_import_status)"
                      >mdi-translate-variant</v-icon>
                      {{ importLabel(page.transcription_import_status) }}
                    </v-chip>
                  </template>
                  <span>Transcription — {{ importLabel(page.transcription_import_status) }}</span>
                </v-tooltip>
              </td>
              <td class="text-center">
                <v-tooltip
                  :text="page.origin_url ? 'View in eScriptorium' : 'Source unavailable'"
                  location="bottom"
                >
                  <template v-slot:activator="{ props }">
                    <v-btn
                      v-bind="props"
                      size="small"
                      :disabled="!page.origin_url"
                      :href="page.origin_url"
                      target="_blank"
                      @click.stop
                      class="source-btn"
                    >
                      <img
                        :src="require('@/assets/escriptorium.png')"
                        width="20"
                        height="20"
                        :style="{ opacity: page.origin_url ? 1 : 0.3 }"
                      />
                    </v-btn>
                  </template>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div v-else class="empty-state">
        <v-container class="text-center">
          <v-icon size="64" :color="isDark ? 'grey lighten-1' : 'grey darken-1'">mdi-emoticon-sad-outline</v-icon>
          <p class="empty-message">No pages found. Why not add or import one? 😊</p>
        </v-container>
      </div>
    </v-card>

  <!-- Empty State Message (Grid View only, when no pages) -->
<div v-else-if="viewMode === 'grid' && pages.length === 0" class="empty-state">
  <v-container class="text-center">
    <v-icon size="64" :color="isDark ? 'grey lighten-1' : 'grey darken-1'">mdi-emoticon-sad-outline</v-icon>
    <p class="empty-message">No pages found. Why not add or import one? 😊</p>
  </v-container>
</div>
    <!-- Create Page Dialog -->
    <v-dialog v-model="createPageDialog" max-width="500px" @keydown.enter="pageFormData.image && createPage()" @keydown.esc="createPageDialog = false">
      <v-card>
        <v-card-title>
          <span class="headline">Create New Page</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="pageForm">
            <v-file-input
              v-model="pageFormData.image"
              label="Upload Image"
              accept="image/*"
              required
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="createPageDialog = false">
            Cancel
          </v-btn>
          <v-btn color="blue darken-1" text @click="createPage">
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Import Page Dialog -->
    <v-dialog v-model="importPageDialog" max-width="500px" @keydown.enter="importPageForm.url && importPageForm.apiToken && importPage()" @keydown.esc="importPageDialog = false">
      <v-card>
        <v-card-title>
          <span class="headline">Import Page from eScriptorium</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="importPageForm">
            <v-text-field
              v-model="importPageForm.url"
              label="eScriptorium Page URL"
              required
            ></v-text-field>
            <v-text-field
              v-model="importPageForm.apiToken"
              label="API Token"
              type="password"
              required
            ></v-text-field>
            <v-checkbox
              v-model="saveApiToken"
              label="Save API Token"
            ></v-checkbox>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="importPageDialog = false">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="importPage">Import</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Projects Browser Dialog -->
    <v-dialog v-model="projectsBrowserDialog" max-width="900px" @keydown.enter="selectedBrowserPages.length > 0 && importSelectedPages()" @keydown.esc="projectsBrowserDialog = false">
  <v-card>
    <v-card-title>
      <span class="headline">Browse Projects</span>
    </v-card-title>
    <v-card-text>
      <!-- API Token Field -->
      <v-form>
        <v-text-field
          v-model="importPageForm.apiToken"
          label="API Token"
          type="password"
          required
        ></v-text-field>
        <v-row align="stretch">
          <v-col cols="auto">
        <v-checkbox
          v-model="saveApiToken"
          label="Save API Token"
        ></v-checkbox>
      </v-col>
      <v-col cols="auto">
        <v-btn
      color="black darken-1"
      text
      @click="fetchProjects"
      :disabled="!importPageForm.apiToken"
      class="normal-case-btn"
    >
    <v-icon>mdi-folder-sync</v-icon> Fetch Projects
    </v-btn>
  </v-col>
  </v-row>
      </v-form>

   <!-- Projects List -->
   <v-container v-if="!selectedProject && !selectedDocument">
  <v-text-field
    v-model="browserProjectSearch"
    density="compact"
    label="Search projects"
    prepend-inner-icon="mdi-magnify"
    variant="solo-filled"
    flat
    hide-details
    single-line
    class="mb-2"
  />
  <v-data-table
    :items="browserProjects"
    :headers="projectHeaders"
    item-value="id"
    class="elevation-1"
    dense
    :search="browserProjectSearch"
    :items-per-page="25"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Projects</v-toolbar-title>
      </v-toolbar>
    </template>

    <template v-slot:item="{ item }">
      <tr @click="selectProject(item)" class="clickable-row">
        <td><v-icon>mdi-folder</v-icon> {{ item.name }}</td>
        <td>{{ item.owner}}</td>
        <td>{{ item.documents_count }}</td>
        <td>{{ formatDate(item.created_at) }}</td>
        <td>{{ formatDate(item.updated_at) }}</td>
      </tr>
    </template>
  </v-data-table>
</v-container>



      <!-- Documents -->
      <v-container v-if="selectedProject && !selectedDocument">

  <v-toolbar flat>
    <v-btn icon @click="resetProjectSelection">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <v-toolbar-title>Documents</v-toolbar-title>
  </v-toolbar>
  <v-text-field
    v-model="browserDocumentSearch"
    density="compact"
    label="Search documents"
    prepend-inner-icon="mdi-magnify"
    variant="solo-filled"
    flat
    hide-details
    single-line
    class="mb-2"
  />
  <v-data-table
    :items="browserDocuments"
    :headers="documentHeaders"
    item-value="pk"
    class="elevation-1"
    dense
    :search="browserDocumentSearch"
    :items-per-page="25"
  >
    <template v-slot:item="{ item }">
        <tr @click="selectDocument(item)" class="clickable-row">
          <td><v-icon>mdi-file-document</v-icon> {{ item.name }}</td>
          <td>{{ item.parts_count }}</td>
          <td>{{ formatDate(item.created_at)}}</td>
          <td>{{ formatDate(item.updated_at)}}</td>
        </tr>
    </template>
  </v-data-table>
</v-container>

      <!-- Pages -->
      <v-container v-if="selectedDocument">
        <v-btn icon @click="resetDocumentSelection">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-row class="select-all-row" justify="end">
    <v-col cols="auto">
      <v-btn small color="primary" @click="toggleBrowserSelectAll">
        <v-icon left>mdi-check-all</v-icon> Select All
      </v-btn>
    </v-col>
  </v-row>
        <v-row>
          <v-col
            v-for="page in browserPages"
            :key="page.pk"
            cols="12"
            md="4"
            lg="3"
          >
            <v-card>
              <v-img :src="`${escriptoriumBaseURL}${page.image.thumbnails.card}`"></v-img>
              <v-checkbox
          v-model="selectedBrowserPages"
          :value="page.pk"
          :label="`Page ${page.order+1}`"
        ></v-checkbox>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="projectsBrowserDialog = false">
        Cancel
      </v-btn>
      <v-btn
        color="blue darken-1"
        text
        @click="importSelectedPages"
        :disabled="!selectedBrowserPages.length"
      >
        Import Selected Pages
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <!-- Assignments Overlay -->
    <v-dialog v-model="assignmentsDialog" max-width="860px" @keydown.esc="assignmentsDialog = false">
      <v-card>
        <v-card-title class="d-flex align-center flex-wrap">
          <v-icon class="me-2" color="primary">mdi-account-arrow-right</v-icon>
          <span class="text-h5">Assignments for {{ document.name }}</span>
          <v-spacer></v-spacer>
          <div class="legend">
            <span class="legend-item"><span class="legend-dot" style="background:#E57373"></span>Not transcribed</span>
            <span class="legend-item"><span class="legend-dot" style="background:#FDD835"></span>Transcribed</span>
            <span class="legend-item"><span class="legend-dot" style="background:#66BB6A"></span>Validated</span>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-4" style="max-height: 560px; overflow-y: auto;">
          <div v-if="assignmentsLoading" class="text-center py-6">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <div v-else-if="assignmentUsers.length > 0">
            <v-card
              v-for="u in assignmentUsers"
              :key="u.id"
              class="assignment-user pa-3 mb-3"
              variant="outlined"
            >
              <div class="d-flex align-center mb-2">
                <v-avatar size="36" class="me-2">
                  <img v-if="u.image" :src="u.image" class="circle-image" alt="avatar" />
                  <v-icon v-else>mdi-account-circle</v-icon>
                </v-avatar>
                <div>
                  <div class="font-weight-medium">{{ u.username }}</div>
                  <div class="text-caption text-medium-emphasis">{{ (u.roles || []).join(', ') || 'no role' }}</div>
                </div>
                <v-spacer></v-spacer>
                <div class="status-rectangles">
                  <v-tooltip text="Lines not transcribed" location="bottom">
                    <template v-slot:activator="{ props }">
                      <div class="status-rectangle" v-bind="props" style="background-color:#E57373">
                        {{ u.line_status_summary.not_transcribed }}
                      </div>
                    </template>
                  </v-tooltip>
                  <v-tooltip text="Lines transcribed (to validate)" location="bottom">
                    <template v-slot:activator="{ props }">
                      <div class="status-rectangle" v-bind="props" style="background-color:#FDD835">
                        {{ u.line_status_summary.transcribed }}
                      </div>
                    </template>
                  </v-tooltip>
                  <v-tooltip text="Lines validated" location="bottom">
                    <template v-slot:activator="{ props }">
                      <div class="status-rectangle" v-bind="props" style="background-color:#66BB6A">
                        {{ u.line_status_summary.validated }}
                      </div>
                    </template>
                  </v-tooltip>
                </div>
              </div>

              <!-- Current assignments -->
              <div class="d-flex align-center flex-wrap assignment-chips">
                <v-chip
                  v-if="u.document_assigned"
                  color="primary"
                  size="small"
                  class="ma-1"
                  closable
                  @click:close="setDocumentAssignment(u, false)"
                >
                  <v-icon start size="14">mdi-file-document</v-icon>
                  Whole document
                </v-chip>
                <v-chip
                  v-for="pageId in u.page_ids"
                  :key="pageId"
                  size="small"
                  class="ma-1"
                  closable
                  @click:close="removeAssignedPage(u, pageId)"
                >
                  Page {{ pageNumberById(pageId) }}
                </v-chip>
                <span
                  v-if="!u.document_assigned && u.page_ids.length === 0"
                  class="text-caption text-medium-emphasis ma-1"
                >
                  Nothing assigned
                </span>
              </div>

              <!-- Add assignments -->
              <div class="d-flex align-center mt-2">
                <v-autocomplete
                  v-model="u.newPageIds"
                  :items="availablePagesFor(u)"
                  item-title="label"
                  item-value="id"
                  label="Add pages"
                  density="compact"
                  variant="outlined"
                  hide-details
                  chips
                  multiple
                  clearable
                  class="me-2 assignment-add-select"
                ></v-autocomplete>
                <v-btn
                  color="primary"
                  size="small"
                  :disabled="!u.newPageIds || u.newPageIds.length === 0"
                  :loading="u.updating"
                  @click="addAssignedPages(u)"
                >
                  Assign
                </v-btn>
                <v-btn
                  v-if="!u.document_assigned"
                  color="primary"
                  variant="outlined"
                  size="small"
                  class="ms-2"
                  :loading="u.updating"
                  @click="setDocumentAssignment(u, true)"
                >
                  Assign whole document
                </v-btn>
              </div>
            </v-card>
          </div>
          <div v-else class="text-center py-8">
            <v-icon size="64" color="grey-lighten-1">mdi-account-group-outline</v-icon>
            <p class="text-grey mt-3">No collaborators in this project</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="assignmentsDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import api from "@/plugins/axios";
import axios from "axios";
import { useToast } from "vue-toastification";
const escriptoriumBaseURL = process.env.VUE_APP_ESCRIPTORIUM_BASE_URL;
//console.log("escriptoriumBaseURL", escriptoriumBaseURL);
export default {
  setup() {
    const toast = useToast();
    return { toast };

  },
  data() {
    return {
      viewMode: 'grid', // 'grid' | 'table'
      search: '',
      sortBy: [],
      currentPageDateSort: 'desc',
      exportDialog: false,
      exportOptions: {
        includeImages: true,
        includeLineInfo: true,
        includeTranscriptions: true,
      },
      assignDialog: false,
      assignmentsDialog: false,
      assignmentsLoading: false,
      assignmentUsers: [],
      assignmentPages: [],
    selectedCollaborators: [],
    users: [],
    selectedBrowserPages: [],
    browserPages: [],
    browserProjectSearch: '',
    browserDocumentSearch: '',
      selectedPages: [],
      document: {},
      pages: [],
      loading: true,
      createPageDialog: false,
      importPageDialog: false,
      projectsBrowserDialog: false,
      projects: [],
      documents: [],
      browserDocuments: [],
      browserProjects: [],
      selectedProject: null,
      selectedDocument: null,
      escriptoriumBaseURL: process.env.VUE_APP_ESCRIPTORIUM_BASE_URL,
      pageFormData: {
        image: null,
      },
      importPageForm: {
        url: '',
        apiToken: '',
      },
      saveApiToken: false,
      projectHeaders: [
        { title: "Project Name", key: "name" },
        { title: "Owner", key: "owner" },
        { title: "Documents Count", key: "documents_count" },
        { title: "Created At", key: "created_at" },
        { title: "Updated At", key: "updated_at" },
      ],
      documentHeaders: [
        { title: "Document Name", key: "name" },
        { title: "Pages Count", key: "parts_count" },
        { title: "Created At", key: "created_at" },
        { title: "Updated At", key: "updated_at" },
      ],
      pageBaseHeaders: [
        { title: '', align: 'center', key: 'select', sortable: false },
        { title: 'Page #', align: 'start', key: 'number' },
        { title: 'Created On', align: 'center', key: 'created_at', sortable: true },
        { title: 'Segmentation', align: 'center', key: 'segmentation_import_status', sortable: false },
        { title: 'Transcription', align: 'center', key: 'transcription_import_status', sortable: false },
        { title: 'Source', align: 'center', key: 'origin_url', sortable: false },
      ],
      // Column-specific filters (extendable for more columns)
      filters: {
        number: '',
      },
    }
  },
  mounted() {
    this.fetchDocument();
    this.fetchPages();
    this.fetchUsers();
    // Load cached API token if available
    const cachedToken = localStorage.getItem('prefs.escriptoriumToken');
  if (cachedToken) {
    this.importPageForm.apiToken = cachedToken;
    this.saveApiToken = true; // Set checkbox to checked if token exists
  }
  },
  computed: {
    isDark() {
      return this.$vuetify.theme.global.current.dark;
    },
    areAllBrowserPagesSelected() {
      return this.browserPages.length > 0 &&
             this.selectedBrowserPages.length === this.browserPages.length;
    },
    isAllSelected() {
    return (
      this.pages.length > 0 &&
      this.selectedPages.length === this.pages.length
    );
  },
  isSomeSelected() {
    return (
      this.selectedPages.length > 0 &&
      this.selectedPages.length < this.pages.length
    );
  },
  selectedPagesDetails() {
      return this.pages.filter((page) =>
        this.selectedPages.includes(page.id)
      );
    },
  canManagePages() {
    const userRoles = JSON.parse(localStorage.getItem("roles") || "[]");
    return userRoles.includes("administrator") || userRoles.includes("project_leader");
  },
  pageHeaders() {
    return this.pageBaseHeaders;
  },
  filteredPages() {
    const q = (this.search || '').toString().trim().toLowerCase();
    let base = this.pages;
    // Global search (multi-field)
    if (q) {
      base = base.filter(p => {
        const seg = this.importLabel(p.segmentation_import_status).toLowerCase();
        const tra = this.importLabel(p.transcription_import_status).toLowerCase();
        const num = (p.number != null ? p.number.toString() : '');
        const id = (p.id != null ? p.id.toString() : '');
        const created = (p.created_at ? new Date(p.created_at).toISOString() : '');
        return [seg, tra, num, id, created].some(field => field.includes(q));
      });
    }
    // Column-level filters
    if (this.filters.number) {
      const nq = this.filters.number.toString().trim().toLowerCase();
      base = base.filter(p => (p.number != null ? p.number.toString().toLowerCase().includes(nq) : false));
    }
    return base;
  }
},
  methods: {
    toggleViewMode() {
      if (this.pages.length === 0) return; // guard when empty
      this.viewMode = this.viewMode === 'grid' ? 'table' : 'grid';
    },
    chipColor(state) {
      // reuse importColor mapping (returns a Vuetify color name)
      return this.importColor(state) || 'grey';
    },
    chipVariant(state) {
      const s = (state || '').toString();
      // Make less prominent if not imported / missing
      return ['not_imported', 'missing', 'error'].includes(s) ? 'outlined' : 'flat';
    },
    chipIconColor(state) {
      const variant = this.chipVariant(state);
      if (variant === 'flat') {
        // ensure contrast on filled chips
        return 'white';
      }
      const v = this.importColor(state);
      return v === 'grey' ? undefined : v;
    },
    formatPageCreated(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const now = new Date();
      const diffMs = now - date;
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      if (diffDays === 0) {
        return `Today ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
      } else if (diffDays === 1) {
        return `Yesterday ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
      } else if (diffDays < 7) {
        return `${date.toLocaleDateString([], { weekday: 'short' })} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
      }
      return date.toLocaleDateString([], { year: 'numeric', month: 'short', day: 'numeric' });
    },
    togglePageDateSort() {
      this.currentPageDateSort = this.currentPageDateSort === 'asc' ? 'desc' : 'asc';
      const multiplier = this.currentPageDateSort === 'asc' ? 1 : -1;
      this.pages.sort((a, b) => (new Date(a.created_at) - new Date(b.created_at)) * multiplier);
    },
      resolveNextUrl(next) {
    // uses the same base as your calls in this view
    try { return new URL(next, escriptoriumBaseURL).toString(); }
    catch (_) { return next; }
  },
      importLabel(state) {
    switch ((state || '').toString()) {
      case 'imported':      return 'Imported';
      case 'updated':       return 'Updated';
      case 'missing':       return 'Missing';
      case 'partial':       return 'Partially imported';
      case 'error':         return 'Error';
      case 'new':           return 'New';
      case 'not_imported':
      default:              return 'Not imported';
    }
  },
  // return a Vuetify color name for the icon,
  // and a raw hex for the dot when `raw=true`
  importColor(state, raw = false) {
    const map = {
      imported:     { ui: 'success', hex: '#2e7d32' },
      updated:      { ui: 'primary', hex: '#1976d2' },
      partial:      { ui: 'warning', hex: '#f9a825' },
      missing:      { ui: 'warning', hex: '#f9a825' },
      new:          { ui: 'info',    hex: '#0288d1' },
      error:        { ui: 'error',   hex: '#d32f2f' },
      not_imported: { ui: 'grey',    hex: '#9e9e9e' },
      unknown:      { ui: 'grey',    hex: '#9e9e9e' },
    };
    const key = (state || 'not_imported');
    return raw ? (map[key]?.hex || map.unknown.hex)
               : (map[key]?.ui  || map.unknown.ui);
  },
    wfState(page, key) {
  // eScriptorium workflow status for key ('segment' | 'transcribe' | 'align')
  const wf = page.escriptorium_workflow || page.workflow || {};
  const val = (wf?.[key] || '').toString().toLowerCase();
  return val || null; // 'done' | 'ongoing' | 'pending' | 'error' | null
},
wfLabel(state) {
  switch (state) {
    case 'done':     return 'Imported';
    case 'ongoing':  return 'In progress';
    case 'error':    return 'Error';
    default:         return 'Not imported';
  }
},
wfColor(state) {
  switch (state) {
    case 'done':     return 'success';
    case 'ongoing':  return 'primary';
    case 'pending':  return 'warning';
    case 'error':    return 'error';
    default:         return 'grey';
  }
},

    toggleBrowserSelectAll() {
      if (this.areAllBrowserPagesSelected) {
        this.selectedBrowserPages = [];
      } else {
        // Map over browserPages to get the primary key for each.
        this.selectedBrowserPages = this.browserPages.map(page => page.pk);
      }
    },
    openExportDialog() {
      this.exportDialog = true;
    },
    async confirmExport() {
  if (this.selectedPages.length === 0) {
    this.toast.error("No pages selected for export.");
    return;
  }
  try {
    const pageIds = this.selectedPages.join(",");
    const url = `/api/export/alto/?page_ids=${pageIds}` +
      `&include_images=${this.exportOptions.includeImages}` +
      `&include_line_info=${this.exportOptions.includeLineInfo}` +
      `&include_transcriptions=${this.exportOptions.includeTranscriptions}`;

    const response = await api.get(url, { responseType: 'blob' });

    // Parse the filename from the Content-Disposition header:
    let filename = "export.zip";
    const disposition = response.headers["content-disposition"];
    if (disposition && disposition.indexOf("filename=") !== -1) {
      const filenameRegex = /filename="(.+)"/;
      const matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        filename = matches[1];
      }
    }

    const blob = new Blob([response.data], { type: 'application/zip' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename; // use the parsed filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.toast.success("Export initiated successfully.");
    this.exportDialog = false;
  } catch (error) {
    console.error("Error exporting pages:", error);
    this.toast.error("Failed to export selected pages.");
  }
},

    toggleSelectAll() {
    // If fully selected, clear them; if partially/none, select them all
    if (this.isAllSelected) {
      this.selectedPages = [];
    } else {
      this.selectedPages = this.pages.map((p) => p.id);
    }
  },
    async fetchUsers() {
    try {
      const projectId = this.$route.params.projectId;
      const response = await api.get(`/api/projects/${projectId}/collaborators/`);
      this.users = response.data.map((user) => ({
        id: user.id,
        username: user.username,
        image: user.image,
      }));
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  },
  openAssignDialog() {
    this.assignDialog = true;
    this.fetchUsers(); // Ensure users are fetched when opening the dialog
  },
  async assignPages() {
    const projectId = this.$route.params.projectId;
    const documentId = this.$route.params.documentId;

    try {
      // additive, adds the selected pages without clearing other users existing assignments
      for (const userId of this.selectedCollaborators) {
        await api.post(
          `/api/projects/${projectId}/documents/${documentId}/update_assignments/`,
          { user_id: userId, add_page_ids: this.selectedPages }
        );
      }
      this.toast.success('Pages successfully assigned to collaborators.');
      this.assignDialog = false;
      this.selectedCollaborators = [];
    } catch (error) {
      console.error("Error assigning pages:", error);
      this.toast.error('Failed to assign pages.');
    }
  },
  pageNumberById(pageId) {
    const page = this.assignmentPages.find((p) => p.id === pageId);
    return page ? page.number : pageId;
  },
  availablePagesFor(user) {
    return this.assignmentPages
      .filter((p) => !user.page_ids.includes(p.id))
      .map((p) => ({ id: p.id, label: `Page ${p.number}` }));
  },
  openAssignmentsDialog() {
    this.assignmentsDialog = true;
    this.fetchAssignments();
  },
  async fetchAssignments() {
    this.assignmentsLoading = true;
    try {
      const projectId = this.$route.params.projectId;
      const documentId = this.$route.params.documentId;
      const response = await api.get(
        `/api/projects/${projectId}/documents/${documentId}/assignments/`
      );
      this.assignmentPages = response.data.pages;
      this.assignmentUsers = response.data.users.map((u) => ({
        ...u,
        newPageIds: [],
        updating: false,
      }));
    } catch (error) {
      console.error("Error fetching assignments:", error);
      this.toast.error("Failed to load assignments.");
    } finally {
      this.assignmentsLoading = false;
    }
  },
  async updateAssignments(user, payload) {
    const projectId = this.$route.params.projectId;
    const documentId = this.$route.params.documentId;
    user.updating = true;
    try {
      await api.post(
        `/api/projects/${projectId}/documents/${documentId}/update_assignments/`,
        { user_id: user.id, ...payload }
      );
      await this.fetchAssignments();
    } catch (error) {
      console.error("Error updating assignments:", error);
      this.toast.error("Failed to update assignments.");
    } finally {
      user.updating = false;
    }
  },
  addAssignedPages(user) {
    if (!user.newPageIds || user.newPageIds.length === 0) return;
    this.updateAssignments(user, { add_page_ids: user.newPageIds });
  },
  removeAssignedPage(user, pageId) {
    this.updateAssignments(user, { remove_page_ids: [pageId] });
  },
  setDocumentAssignment(user, assigned) {
    this.updateAssignments(user, { assign_document: assigned });
  },
    handleDeletePages() {
    if (this.selectedPages.length > 0) {
      if (confirm("Are you sure you want to delete the selected pages?")) {
        this.selectedPages.forEach((pageId) => {
          this.deletePage(pageId);
        });
        this.selectedPages = [];
      }
    }
  },
    openProjectsBrowserDialog() {
      this.projectsBrowserDialog = true;
      this.fetchProjects();
    },
    async fetchDocument() {
      try {
        const projectId = this.$route.params.projectId;
        const documentId = this.$route.params.documentId;
        const response = await api.get(`/api/projects/${projectId}/documents/${documentId}/`);
        this.document = response.data;
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    },
    async fetchPages() {
      try {
        const projectId = this.$route.params.projectId;
        const documentId = this.$route.params.documentId;
        const response = await api.get(
          `/api/projects/${projectId}/documents/${documentId}/pages/`
        );
        this.pages = response.data;
      } catch (error) {
        console.error("Error fetching pages:", error);
      } finally {
        this.loading = false;
      }
    },
    goToPage(pageId) {
      const projectId = this.$route.params.projectId;
      const documentId = this.document.id;
      this.$router.push(`/projects/${projectId}/documents/${documentId}/pages/${pageId}`);
    },
    goToProjectDetails() {
      const projectId = this.$route.params.projectId;
      this.$router.push(`/projects/${projectId}`);
    },
    openCreatePageDialog() {
      this.pageFormData = { image: null };
      this.createPageDialog = true;
    },
    async createPage() {
      const projectId = this.$route.params.projectId;
      const documentId = this.$route.params.documentId;

      const formData = new FormData();
      if (this.pageFormData.image) {
        formData.append("image", this.pageFormData.image);
      }

      try {
        const response = await api.post(
          `/api/projects/${projectId}/documents/${documentId}/pages/`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        this.pages.push(response.data);
        this.createPageDialog = false;
      } catch (error) {
        console.error("Error creating page:", error);
      }
    },
    openImportPageDialog() {
      this.importPageForm.url = '';
      this.importPageDialog = true;
    },
    async importPage() {
      const projectId = this.$route.params.projectId;
      const documentId = this.$route.params.documentId;

      const payload = {
        url: this.importPageForm.url,
        api_token: this.importPageForm.apiToken,
      };

      try {
        const response = await api.post(
          `/api/projects/${projectId}/documents/${documentId}/import_page/`,
          payload
        );
        if (this.saveApiToken) {
      localStorage.setItem('prefs.escriptoriumToken', this.importPageForm.apiToken);
    }
        if (response.data && response.data.success) {
          this.fetchPages();
          this.importPageDialog = false;
          this.toast.success(response.data.success);
        } else {
          this.toast.error("Unexpected response from the server.");
        }
      } catch (error) {
        console.error("Error during importPage:", error);

        if (error.response) {
          const backendError = error.response.data ? error.response.data.error : "Unknown error from backend.";
          this.toast.error(`Import failed: ${backendError}`);
        } else if (error.request) {
          console.error("Request details:", error.request);
          this.toast.error("No response received from the server.");
        } else {
          console.error("Error message:", error.message);
          this.toast.error(`An unexpected error occurred: ${error.message}`);
        }
      }
    },
    confirmDeletePage(pageId) {
      if (confirm("Are you sure you want to delete this page?")) {
        this.deletePage(pageId);
      }
    },
    async deletePage(pageId) {
      try {
        const projectId = this.$route.params.projectId;
        const documentId = this.$route.params.documentId;

        await api.delete(
          `/api/projects/${projectId}/documents/${documentId}/pages/${pageId}/`
        );

        this.pages = this.pages.filter((page) => page.id !== pageId);
        this.toast.success("Page deleted successfully.");
      } catch (error) {
        console.error("Error deleting page:", error);
        this.toast.error("Failed to delete the page.");
      }
    },
    async fetchProjects() {
      this.selectedProject = null;
      this.selectedDocument = null;
      this.selectedPages = [];
      this.browserProjects = [];
      this.browserDocuments = [];
      this.browserPages = [];
      this.browserProjectSearch = '';
      this.browserDocumentSearch = '';
    try {
      if (!this.importPageForm.apiToken) {
        this.toast.error("API Token is required to fetch projects.");
        return;
      }
      const headers = { Authorization: `Token ${this.importPageForm.apiToken}` };
      let url = `${escriptoriumBaseURL}/api/projects/`;
      const all = [];
      while (url) {
        const { data } = await axios.get(url, { headers });
        all.push(...(data.results || []));
        url = data.next ? this.resolveNextUrl(data.next) : null;
      }
      if (this.saveApiToken) {
        localStorage.setItem('prefs.escriptoriumToken', this.importPageForm.apiToken);
      }
      this.browserProjects = all;
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  },
  async fetchDocuments(projectId) {
    try {
      const headers = { Authorization: `Token ${this.importPageForm.apiToken}` };
      let url = `${escriptoriumBaseURL}/api/documents/?project=${projectId}`;
      const all = [];
      while (url) {
        const { data } = await axios.get(url, { headers });
        all.push(...(data.results || []));
        url = data.next ? this.resolveNextUrl(data.next) : null;
      }
      this.browserDocuments = all;
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
  },
  async fetchPagesFromDocument(documentId) {
    try {
      const headers = { Authorization: `Token ${this.importPageForm.apiToken}` };
      let url = `${escriptoriumBaseURL}/api/documents/${documentId}/parts/?ordering=order&paginate_by=50`;
      const all = [];

      while (url) {
        const { data } = await axios.get(url, { headers });
        all.push(...(data.results || []));
        url = data.next ? this.resolveNextUrl(data.next) : null;
        // (optional) const total = data.count;
      }

      this.browserPages = all;
    } catch (error) {
      console.error("Error fetching pages:", error);
    }
  },
  selectProject(project) {
    this.selectedProject = project;
    this.fetchDocuments(project.id);
  },
  resetProjectSelection() {
    this.selectedProject = null;
    this.browserDocuments = [];
  },
  selectDocument(document) {
    this.selectedDocument = document;
    this.fetchPagesFromDocument(document.pk);
  },
  resetDocumentSelection() {
    this.selectedDocument = null;
    this.browserPages = [];
  },
  importSelectedPages() {
    this.selectedBrowserPages.forEach((pagePk) => {
      this.importPageForm.url = `${escriptoriumBaseURL}/document/${this.selectedDocument.pk}/part/${pagePk}/`;
      this.importPage();
    });
    this.projectsBrowserDialog = false;
  },
  formatDate(dateString) {
      if (!dateString) return ''; // Handle empty or null dates
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('en-US', {
        dateStyle: 'medium',
        timeStyle: 'short',
      }).format(date);
    },
},
};
</script>


<style scoped>
.image-container {
  position: relative;
}

.delete-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 2;
  background-color: rgb(var(--v-theme-surface));
  border-radius: 50%;
  width: 30px;
  height: 30px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.delete-btn v-icon {
  font-size: 14px;
}

.page-card {
  cursor: pointer;
  margin: 10px;
}

.clickable-card {
  transition: box-shadow 0.2s;
  width: 200px;
}

.clickable-card:hover {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2); /* Adds hover effect */
}

.custom-container {
  margin: 30px !important;
  padding: 0 !important;
  max-width: 100% !important;
}

.toolbar-btn {
  margin-right: 10px;
}

.back-btn {
  margin-left: 10px;
}
.page-number {
  font-size: 12px;
}
.clickable-row {
  cursor: pointer; /* Changes the cursor to a pointer */
  transition: background-color 0.2s; /* Smooth transition effect */
}

.clickable-row:hover {
  background-color: rgba(var(--v-border-color), 0.08);
}
.normal-case-btn {
  text-transform: none !important;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px; /* Adjust as necessary */
  color: var(--v-theme-on-background); /* Automatically adapts to light/dark theme */
  opacity: 0.7; /* Subtle faded effect */
}

.empty-message {
  font-size: 1.2rem;
  margin-top: 16px;
  color: inherit;
}
.page-checkbox {
  position: absolute; /* Position it over the thumbnail */
  top: 10px; /* Adjust vertical position */
  left: 10px; /* Adjust horizontal position */
  z-index: 3; /* Ensure it's above the thumbnail */
  background-color: rgba(var(--v-theme-surface), 0.8);
  border-radius: 50%; /* Circular checkbox background */
  padding: 4px; /* Control the inner padding for the checkbox */
  width: 30px; /* Adjust width */
  height: 30px; /* Adjust height */
  display: flex; /* Center the checkbox content */
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  transition: background-color 0.3s ease; /* Add smooth hover effect */
}

.page-checkbox:hover {
  background-color: rgb(var(--v-theme-surface));
}

.export-card {
  border-radius: 8px;
  overflow: hidden;
}
.export-card-title {
  background-color: rgb(var(--v-theme-primary));
  color: rgb(var(--v-theme-on-primary));
  font-weight: bold;
  font-size: 1.2rem;
}
.status-row {
  display: flex;
  align-items: center;
  justify-content: center;   /* or space-around, up to you */
  padding: 6px 8px 0;
}

.status-item {
  display: flex;
  align-items: center;
  padding: 0 21px;           /* matches the reference look */
}

/* the thin vertical divider */
.status-item:not(:last-child) {
  border-right: 1px solid rgba(0, 0, 0, 0.12);   /* light theme */
}

/* tweak for dark theme (Vuetify adds v-theme--dark on the root) */
:deep(.v-theme--dark) .status-row .status-item:not(:last-child) {
  border-right-color: rgba(255, 255, 255, 0.2);
}

.status-icon {
  font-size: 20px;
  transition: opacity .15s ease;
}
.status-tip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}
.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
}
.column-filter {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
.column-filter .filter-input :deep(input) {
  padding: 0 4px !important;
  text-align: left;
}
.column-filter .header-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  opacity: 0.75;
}

.source-btn {
  border-radius: 4px !important;
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
}

/* Assignments overlay */
.assignment-user {
  border-radius: 12px;
}
.assignment-chips {
  min-height: 36px;
}
.assignment-add-select {
  max-width: 380px;
}
.circle-image {
  object-fit: cover;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  display: block;
}
.status-rectangles {
  display: flex;
  align-items: center;
  gap: 4px;
}
.status-rectangle {
  min-width: 30px;
  height: 20px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  font-weight: bold;
  border-radius: 4px;
  cursor: default;
}
.legend {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  opacity: 0.8;
}
.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}
</style>
